module.exports = __webpack_public_path__ + "img/zf_4@2x.73ef6a7c.png";